import { useEffect, useState } from 'react';
const getInitialInnerWidth = () => {
    var _a;
    const documentWidth = window.innerWidth || ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.width);
    if (documentWidth == 0) {
        return;
    }
    return documentWidth;
};
const useInnerWidth = () => {
    const [currentInnerWidth, setCurrentInnerWidth] = useState(getInitialInnerWidth());
    const getCurrentInnerWidth = () => {
        var _a;
        const documentWidth = window.innerWidth || ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.width);
        if (documentWidth == 0) {
            return;
        }
        return documentWidth;
    };
    const handleResize = () => {
        const currentIw = getCurrentInnerWidth();
        if (currentIw && currentIw !== currentInnerWidth) {
            setCurrentInnerWidth(currentIw);
        }
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });
    return currentInnerWidth;
};
export default useInnerWidth;
